// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"354":"024f89c5","368":"5c83349e","575":"b1509884","624":"2239ed8b","668":"f583838e","738":"ad5a6332","838":"3787910e"}[chunkId] + ".js";
};